/**
 * Get the next number in the custom Fibonacci sequence.
 * Skips the duplicate 1 to produce: 1, 2, 3, 5, 8, 13, 21, ...
 * Matches the Laravel `getNextFib()` implementation.
 *
 * Copied verbatim from `level-progress.tsx` — do not "fix" the math here even
 * if something looks off; this must stay byte-for-byte behavior-identical to
 * the original since it's the source of truth the Laravel backend agrees with.
 */
export const getNextFib = (n: number): number => {
    if (n === 0) return 1
    if (n === 1) return 2
    if (n === 2) return 3
    return Math.round((n * (1 + Math.sqrt(5))) / 2)
}

/**
 * Get the threshold at which the level owning `threshold` began (in raw score
 * units, i.e. multiples of 1000). `threshold` is itself a Fibonacci
 * threshold (as returned by `getLevelFromScore`'s `nextThreshold`); the
 * result is the previous value in that same Fibonacci sequence, i.e. the
 * score at which the current level started.
 */
export const getPrevThreshold = (threshold: number): number => {
    if (threshold <= 1000) return 0
    const target = threshold / 1000
    let curr = 0
    while (true) {
        const next = getNextFib(curr)
        if (next >= target) return curr * 1000
        curr = next
    }
}

/** Percent fill of the level progress bar — same formula LevelProgress renders. */
export const getLevelProgressPercent = (score: number, nextThreshold: number): number => {
    const prevThreshold = getPrevThreshold(nextThreshold)
    const range = nextThreshold - prevThreshold
    const progress = range > 0 ? ((score - prevThreshold) / range) * 100 : 0
    return Math.max(0, Math.min(100, progress))
}
